import { Badge, Collapse, Fade, IconButton, Tab, Tabs, Dialog, DialogContent, CircularProgress } from "@mui/material";
import { motion } from "framer-motion";
import { useContext, useEffect, useState, useRef, memo, useMemo } from "react";
import MenuLateral from "../../../componentes/gerais/Menu";
import TopoMenu from "../../../componentes/gerais/TopoMenu";
import { ContextoGeral } from "../../../contextos/ContextoGeral";
import { configAnim } from "../../../servicos/config/configAnim";
import { MdClose, MdSend } from "react-icons/md";
import { ChatContext } from "../../../contextos/ContextoChat";

import { copy, print } from "../../../servicos/Uteis";
import { APISEM } from "../../../servicos/APISEM";
import ServicoAPI from "../../../servicos/ServicoAPI";
import { ChatServicoCorpo, ChatServicos, dateFormat } from "./ChatServicos";
import { BlocoEnviar } from "./Comp";
import { CopyAll } from "@mui/icons-material";
import { Spinner } from "../../../componentes/Spinner";
import { renderMsgContent } from "./MsgMedia";

export default function Chat() {
	const { dados } = useContext(ContextoGeral)
	const { chat, dispatch, status } = useContext(ChatContext)

	const [tab, setTab] = useState(dados?.chatConfig?.entregadorPodeIniciarChat == "S" ? "central" : "servicos")
	const [menu, setMenu] = useState(false)

	function counter() {
		let count = 0
		if (chat?.salas?.servicos) Object.keys(chat?.salas?.servicos).forEach(key => {
			if (chat?.salas?.servicos[key]?.unread)
				count += chat?.salas?.servicos[key]?.unread
		})
		return count
	}

	useEffect(() => {
		if (tab == "central" && chat?.salas?.central?.idSala)
			dispatch({ type: "clearCentral" })
	}, [tab])

	return <div>
		<motion.div
			initial={configAnim.initial}
			animate={configAnim.animate}
			exit={configAnim.exit}
			transition={configAnim.transition}
		>
			<div style={{ padding: "1rem" }}>
				<TopoMenu voltar="/app/home" titulo="CHAT" setShow={setMenu} />
				{status == 0
					? <Spinner />
					: <Tabs
						variant="pills"
						justify
						value={tab}
						onChange={(e, v) => setTab(v)}
					>
						{dados?.chatConfig?.entregadorPodeIniciarChat == "S" && <Tab label={<>
							<Badge badgeContent={tab == "central" ? 0 : chat?.salas?.central?.unread ?? 0} color="error">
								Central
							</Badge>
						</>} value="central" />}
						{dados?.chatConfig?.clientePodeIniciarChat == "S" && <Tab label={<>
							<Badge badgeContent={tab != "central" ? 0 : counter()} color="error">
								Serviços
							</Badge>
						</>} value="servicos" />}
					</Tabs>}
				<div style={{ position: "relative", height: "calc(var(--app-vh) - 8rem)" }}>
					<div style={{
						height: "100%",
						position: "absolute",
						top: "0",
						left: tab == "central" ? "0%" : "-120%",
						width: "100%",
						marginTop: "1rem",
						overflow: "auto",
						transition: "left 0.5s"
					}}>
						{dados?.chatConfig?.entregadorPodeIniciarChat == "S" && tab == "central" && <ChatCentral />}
					</div>
					<div style={{
						height: "100%",
						position: "absolute",
						top: "0",
						left: tab == "central" ? "120%" : "0%",
						width: "100%",
						marginTop: "1rem",
						transition: "left 0.5s",
					}}>
						{dados?.chatConfig?.clientePodeIniciarChat == "S" && tab != "central" && <ChatServicos />}
					</div>
					{dados?.chatConfig?.entregadorPodeIniciarChat != "S" && dados?.chatConfig?.clientePodeIniciarChat != "S" && <div>
						<div className="alert alert-danger mt-3 text-center">
							Chat indisponível, contate seu administrador.
						</div>
					</div>}
				</div>
			</div>
		</motion.div>
		<MenuLateral show={menu} setShow={setMenu} ativo="0" />
	</div>
}

function ChatCentral() {
	const { dados } = useContext(ContextoGeral)
	const { socket, chat, dispatch, connectCentral } = useContext(ChatContext)

	const [msg, setMsg] = useState("")
	const [loading, setLoading] = useState(true)
	const [init, setInit] = useState(false)
	const [API, setAPI] = useState(null)

	function enviarMensagem() {
		if (msg == "") {
			print("mensagem vazia")
			return
		}

		if (!chat?.salas?.central?.idSala) {
			print("sala não conectada")
			return
		}

		if (socket) {
			socket.emit("sendMessageToRoom", {
				roomName: `${dados.chatConfig.idConfig}_P${dados.idProf}`,
				salaId: chat?.salas?.central?.idSala,
				message: msg,
				nome: dados.nome
			})

			setMsg("")
		} else console.error("socket não conectado")
	}

	async function buscarMsgsAntigas() {
		if (chat) {
			const central = chat?.salas?.central
			if (central?.idSala) {
				const api = new APISEM(dados.dominio)
				// setAPI(api)
				await api.buscarMsgSala({
					idSala: central.idSala,
					limite: 10,
					idBusca: central?.previousID ?? null
				}).then(r => {
					if (r.status == "200") {
						const data = r.dados.dados
						if (data[data.length - 1]?.id)
							dispatch({
								type: "prevCentral", msgs: data.map(item => {
									return {
										id: item.id,
										txt: item.mensagem,
										name: item.nome,
										outro: item.idUsuario != dados.idProf,
										enviado: true,
										recebido: true,
										date: new Date(item.timeCadastro * 1000)
									}
								}), previousID: data[data.length - 1].id
							})
					}
				}).finally(() => setLoading(false))
				dispatch({ type: "clearCentral" })
			}
		}
	}

	const handleFinishGallery = (url) => {
		// Opção A: só colocar o link no input de mensagem
		// setMsg(prev => (prev ? `${prev} ${url}` : url));

		// — OU —

		// Opção B: enviar imediatamente o link como mensagem
		if (socket && chat?.salas?.central?.idSala) {
		  socket.emit("sendMessageToRoom", {
		    roomName: `${dados.chatConfig.idConfig}_P${dados.idProf}`,
		    salaId: chat?.salas?.central?.idSala,
		    message: url,
		    nome: dados.nome
		  });
		}
	};

	const handleErrorGallery = (erro) => {
		console.error("Erro ao enviar imagem:", erro);
		// se quiser: print(erro) ou um toast/alert
	};

	useEffect(() => {
		if (chat?.salas?.central?.unread > 0)
			dispatch({ type: "clearCentral" })
	}, [chat])

	useEffect(() => {
		if (loading) {
			console.log("dados", JSON.stringify(dados, null, 3));

			console.log("chat", JSON.stringify(chat, null, 3));

			if (!chat?.salas?.central?.idSala) connectCentral()

			const central = chat?.salas?.central
			if (central?.idSala && !init) {
				const api = new APISEM(dados.dominio)
				setAPI(api)
				if (central?.mensagens.length < 10) {
					buscarMsgsAntigas()
					setInit(true)
				}
				else setLoading(false)
				dispatch({ type: "clearCentral" })
			}
		}
	}, [loading, chat])
	console.log('chat', chat);

	return <div style={{
		display: "flex",
		flexDirection: "column",
		height: "100%"
	}}>
		<div style={{
			height: "100%",
			overflowY: "auto",
			display: "flex",
			flexDirection: "column-reverse"
		}}>
			<Fade in={loading} unmountOnExit>
				<div style={{
					background: "white",
					height: "100%",
					width: "100%",
					position: "absolute",
					top: 0,
					display: "flex",
					alignItems: "center",
					justifyContent: "center"
				}}>
					<div className="w-full h-full"><Spinner /></div>
				</div>
			</Fade>
			{
				chat?.salas?.central?.mensagens.map((m) =>
					<div key={m.id ?? `${m.date?.getTime?.() || ""}-${(m.txt || "").slice(0, 20)}`} className="flex">
						{m.outro && <IconButton className="opacity-25" onClick={() => copy(m.txt)}>
							<CopyAll />
						</IconButton>}
						<div
							style={{
								background: "white",
								padding: "0.5rem",
								borderRadius: "0.5rem",
								width: "80%",
								background: m.outro ? "var(--primaria-brighter)" : "var(--primaria)",
								color: "white",
								lineHeight: 1.1,
								marginTop: "3px",
								marginBottom: "3px",
								marginRight: "0.5rem",
								marginLeft: m.outro ? "0.5rem" : "auto",
								boxShadow: "0 0 15px -7px rgba(0,0,0,1)",
								textWrap: "wrap"
							}}
						>
							<div style={{
								lineHeight: 1,
								fontSize: "12px",
								fontWeight: 700,
								display: "flex",
								justifyContent: "space-between"
							}}>
								<div>{m.name}</div>
								<div>{dateFormat(m.date)}</div>
							</div>
							<div className="break-all font-thin">
								{renderMsgContent(m.txt)}
							</div>
						</div>
						{!m.outro && <IconButton className="opacity-25" onClick={() => copy(m.txt)}>
							<CopyAll />
						</IconButton>}
					</div>)
			}
			<button className="btn btn-info text-white mb-3" disabled={!API} onClick={buscarMsgsAntigas}>
				Buscar mais mensagens
			</button>
		</div >
		<BlocoEnviar
			loading={loading}
			msg={msg}
			onChange={e => setMsg(e.target.value)}
			onSend={() => enviarMensagem()}
			disabled={loading}
			onFinishGallery={handleFinishGallery}
			onErrorGallery={handleErrorGallery}
		/>
	</div >
}
